export default __webpack_public_path__ + "static/media/INTP-4.7fdeec4a.png";